import { useTranslation } from 'next-i18next';

export const useGetSchoolTypeOptions = (): {
  label: string;
  value: string;
}[] => {
  const { t } = useTranslation(['common']);

  return [
    { label: t('common:school.level.kindergarten'), value: 'KINDERGARTEN' },
    { label: t('common:school.level.primary'), value: 'PRIMARY' },
    { label: t('common:school.level.middle'), value: 'MIDDLE' },
    { label: t('common:school.level.high'), value: 'HIGH' },
    { label: t('common:school.level.college'), value: 'COLLEGE' },
    { label: t('common:school.level.other'), value: 'OTHER' },
  ];
};

export const useGetUsagePurposeOptions = (): {
  label: string;
  value: string;
}[] => {
  const { t } = useTranslation(['common']);

  return [
    {
      label: t('common:signup.company.purpose1'),
      value: 'company_purpose_1',
    },
    { label: t('common:signup.company.purpose2'), value: 'company_purpose_2' },
    {
      label: t('common:signup.company.purpose3'),
      value: 'company_purpose_3',
    },
    {
      label: t('common:signup.company.purpose4'),
      value: 'company_purpose_4',
    },
    {
      label: t('common:signup.company.purpose5'),
      value: 'company_purpose_5',
    },
  ];
};
